import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Buffer } from 'buffer';

import { Storages } from 'src/appConstants';
import { Authentication } from 'src/types/dto';

type UserStore = {
	id: number;
	email: string;
	name: string;
	userStatus: string;
	token: string;
	accessToken: string;
	setUser: (user: Authentication) => void;
	clear: () => void;
};

const useUserStore = create<UserStore>()(
	persist(
		(set, get) => ({
			id: 0,
			email: '',
			name: '',
			userStatus: '',
			token: '',
			accessToken: '',
			setUser: ({ id, email, token, name, userStatus }: Authentication) => {
				const encodedCredentials = Buffer.from(
					`${email}:${token}`,
					'utf-8'
				).toString('base64');
				if (userStatus === 'pending') {
					set({ id, email, token, name, userStatus });
				} else {
					set({
						id,
						email,
						token,
						accessToken: encodedCredentials,
						name,
						userStatus,
					});
				}
			},
			clear: () =>
				set({
					id: 0,
					email: '',
					name: '',
					userStatus: '',
					token: '',
					accessToken: '',
				}),
		}),
		{ name: Storages.USER }
	)
);

if (typeof window !== 'undefined') {
	window.addEventListener('storage', event => {
		if (event.key === 'uticket:logout') {
			useUserStore.getState().clear();
			window.localStorage.removeItem('uticket:logout');
		}
	});
}

export default useUserStore;
